import * as db from './db/db';
const publicVapidKey =
  "BObQIcOMBBe3dX9WRzAW3iS1ondkhujqmlqLDrd_lC32hnLMStS0Jh8QeN_BdbNrXBEwJv5ywPnjicaDtwbhHHQ";
const baseUrl = (process.env.PUBLIC_URL==='/'?'': process.env.PUBLIC_URL) ||'';


export const methods = {
  async send(type) {
    // Register Push
    console.log("Registering Push...");
    navigator.serviceWorker.ready
      .then((sw) => {
        sw.pushManager.getSubscription().then(function(subscription) {
          if(subscription !== undefined && subscription !== null && subscription !== undefined){
            subscription.unsubscribe().then(function(successful) {
              // You've successfully unsubscribed
              console.log('You have successfully unsubscribed');
              
              sw.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
              }).then((data) => {
                return db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                  var userSites = '';
                 
                  if (userInfo[0].userSecondaryCompanys) {
                    userSites = userInfo[0].userPrimaryCompany.companyURL + '*';
                    userInfo[0].userSecondaryCompanys.forEach((company, i) => {
                      userSites = userSites + company.companyURL + '*';
                    });
                  }
                  return fetch(baseUrl + "/api/subscribe", {
                    method: "POST",
                    body: JSON.stringify({ user: { userId: userInfo[0].userId, UserCompanys: userSites}, subscribtion: data, type:type }),
                    headers: {
                      "content-type": "application/json"
                    }
                  }).then(res => {
                    console.log("Push Registered...");
                    console.log("Sending Push...");
                    console.log("Push Sent...");
                  });
                });
              });
            }).catch(function(e) {
              // Unsubscription failed
            })
          }else{
            sw.pushManager.subscribe({
              userVisibleOnly: true,
              applicationServerKey: urlBase64ToUint8Array(publicVapidKey)
            }).then((data) => {
              return db.idbMethods.getAll(db.userInfo).then((userInfo) => {
                var userSites = '';
                userSites = userInfo[0].userPrimaryCompany.companyURL + '*';
                if (userInfo[0].userSecondaryCompanys) {
                  userInfo[0].userSecondaryCompanys.forEach((company, i) => {
                    userSites = userSites + company.companyURL + '*';
                  });
                }
                
                return fetch(baseUrl + "/api/subscribe", {
                  method: "POST",
                  body: JSON.stringify({ user: { userId: userInfo[0].userId, UserCompanys: userSites }, subscribtion: data,type: type }),
                  headers: {
                    "content-type": "application/json"
                  }
                }).then(res => {
                  console.log("Push Registered...");
                  console.log("Sending Push...");
                  console.log("Push Sent...");
                });
              });
            });
          }
        })      
      });
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, "+")
    .replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}